<template>
  <div :class="divWidthChange" class="conteudoWidth">
    <fccTitlePage titlePage="Ícones" />
    <b-row>
      <b-col lg="2" md="4" class="mx-5">
        <fcc-input v-model="icone" @input="buscarIcones()">Buscar</fcc-input>
      </b-col>
    </b-row>
    <b-row v-if="iconesFiltrados.length > 0" class="px-5 mt-5">
      <b-col
        lg="2"
        md="3"
        sm="4"
        class="mb-3"
        v-for="(item, index) in iconesFiltrados"
        :key="index"
      >
        <font-awesome-icon :icon="item" size="lg" class="mr-2 text-primary" />
        {{ item }}
      </b-col>
    </b-row>
    <b-row v-else class="px-5 mt-5">
      <b-col cols="12"> Nenhum resultado encontrado. </b-col>
    </b-row>
  </div>
</template>
<script>
import IconsBase from './icones.js'
export default {
  data() {
    return {
      icone: '',
      iconesFiltrados: IconsBase,
      icones: IconsBase
    }
  },
  methods: {
    buscarIcones() {
      if (this.icone === '') {
        this.iconesFiltrados = this.icones
      }
      this.iconesFiltrados = this.icones.filter((element) =>
        element.toLowerCase().includes(this.icone.toLowerCase())
      )
    }
  }
}
</script>